export default class Form {
  constructor (fields) {
    this.fields = fields;
    this.errors = {};
    this.busy = false;
  }

  static from (fields) {
    const instance = new this(fields);

    fields.forEach(field => instance[field] = '');

    return instance;
  }

  has (key) {
    return !! this.errors[key];
  }

  error (key) {
    const errors = this.errors[key];

    if (! errors) {
      return [];
    }

    return Array.isArray(errors) ? errors : [ errors ];
  }

  fill (data) {
    this.fields.forEach((field) => {
      if (data[field]) {
        this[field] = data[field];
      }
    })

    return this;
  }

  run () {
    this.busy = true;
    this.errors = {};

    return this.fields
      .filter(field => !! this[field])
      .map((field) => ({ [field]: this[field] }))
      .reduce((pr, cr) => Object.assign(pr, cr), {});
  }

  update ({ response = {}, status }) {
    this.busy = false;
    this.errors = response.data && response.data.errors || {};
  }
};



// WEBPACK FOOTER //
// ./src/core/form.js